import styled from "styled-components";
export const BadgesTableContainer = styled.div``;

export const TitleLabel = styled.p``;

export const TableContainer = styled.div`
  border: solid #ededed 2px;
`;
